<template>
	<ListPage :query="query" :total="total" row-key="id" v-loading="loading" :data="tableData"
		@size-change="handleSizeChange" @current-change="handleCurrentChange" @search="handleSearch"
		@reset="resetQuery">
		<template slot="filters">
			<el-form-item label="菜单名称" prop="word">
				<el-input v-model="query.word" placeholder="请输入菜单名称" clearable @keyup.enter.native="handleSearch" />
			</el-form-item>
			<el-form-item label="状态" prop="status">
				<el-select v-model="query.status" placeholder="请选择状态" clearable>
					<el-option label="启用" value="1"></el-option>
					<el-option label="禁用" value="0"></el-option>
				</el-select>
			</el-form-item>
		</template>
		<template slot="btns">
			<el-button icon="el-icon-plus" size="mini" type="primary" @click="handleAdd">
				新增菜单
			</el-button>
		</template>
		<template slot="columns">
			<el-table-column label="菜单名称" align="center" prop="name" />
			<el-table-column label="图标" align="center" prop="icon ">
				<template slot-scope="{ row }">
					<img style="height: 20px" :src="row.icon" alt="">
				</template>
			</el-table-column>
			<el-table-column label="路由地址" align="center" prop="route" />
			<el-table-column label="排序号" align="center" prop="sort" />
			<el-table-column label="状态" align="center" prop="status">
				<template slot-scope="{ row }">
					<el-tag :type="row.status == 1 ? 'success' : 'danger'">
						{{ ['禁用', '启用'][row.status] }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="200">
				<template slot-scope="{ row }">
					<el-link :underline="false" type="primary" @click="handleEdit(row)">
						编辑
					</el-link>
					<el-link style="margin: 0 10px" :underline="false" type="primary" @click="handleAddChild(row)">
						添加子菜单
					</el-link>
					<el-link :underline="false" type="danger" @click="handleDel(row)">
						删除
					</el-link>
				</template>
			</el-table-column>
		</template>
	</ListPage>
</template>

<script>
import { page, del } from "@/api/permission/menu";
import listMixin from '@/mixins/list';

export default {
	data() {
		return {
			// 查询参数
			query: {
				word: "",
				status: undefined
			},
		};
	},
	mixins: [listMixin],
	methods: {
		search() {
			this.loading = true;
			const params = {
				...this.query,
			};
			page(params).then(({ code, data, message }) => {
				if (code == 200) {
					this.tableData = data.records;
					this.total = data.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
		handleAdd() {
			this.$router.push("/permission/menu/form");
		},
		handleEdit(row) {
			this.$router.push({ path: "/permission/menu/form", query: { id: row.id } });
		},
		handleAddChild(row) {
			this.$router.push({ path: "/permission/menu/form", query: { pid: row.id } });
		},
		handleDel(row) {
			this.$confirm("是否删除该菜单?", "提示", {
				type: "warning",
			})
				.then(() => {
					del(row.id).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("删除成功");
							this.search();
						} else {
							this.$message.error(message);
						}
					});
				})
				.catch(() => { });
		},
	},
};
</script>